<template>
  <div>
    <back-header :head-title="title"></back-header>
    <div class="video">
      <div class="video_window">
        <div class="video_area" v-show="showVideoArea">
          <video
            id="media"
            :src="videoTopSrc"
            :poster="videoTopimgSrc"
            controls="controls"
            width="100%"
            height="100%"
            controlslist="nodownload"
          ></video>
        </div>
        <div class="img_area" v-show="!showVideoArea" @click="goUrl(videoTopSrc)">
          <img :src="videoTopimgSrc" alt />
        </div>
        <div class="title">{{videoTopTitle}}</div>
      </div>
      <div class="video_tab">
        <ul>
          <li
            :class="[showActive == item.id ?'active':'']"
            v-for="item in tabArr"
            :key="item.id"
            @click="showVideo(item.id,item.val)"
          >{{item.title}}</li>
        </ul>
      </div>
      <div class="video_list">
        <ul class="clear">
          <li v-for="item in videoList" :key="item.id" @click="calTimes(item,item.type)">
            <div>
              <img :src="item.videoUrl" alt />
            </div>
            <div class="video_title">{{item.title}}</div>
            <div class="video_times">
              播放次数：
              <span :ref="item.id">{{item.totalViews}}</span>
            </div>
          </li>
        </ul>
        <div class="load_more" @click="loadMore('more')">加载更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import backHeader from "components/header/backHeader";
import { toast } from "assets/commonjs/toast";
export default {
  data() {
    return {
      title: "教学视频",
      videoList: [],
      companyId: 1,
      category: null,
      tabArr: [
        { title: "全部", id: 0, val: null },
        { title: "新手入门", id: 1, val: 0 },
        { title: "新手进阶", id: 2, val: 1 },
        { title: "技术实战", id: 3, val: 2 }
      ],
      showActive: 0,
      videoTopSrc: "",
      videoTopimgSrc: "",
      videoTopTitle: "",
      pageNum: 0,
      pageSize: 6,
      showVideoArea: true
    };
  },
  mounted() {
    this.getVideoData();
    this.showActive = 0;
  },
  methods: {
    getVideoData(type) {
      let data = {
        companyId: this.companyId,
        category: this.category,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$api.strageList.getVideoData(data).then(res => {
        if (res.data && res.data.code == 0) {
          if (type == "more") {
            if (res.data.result.length == 0) {
              toast("没有更多数据了");
            }
            this.videoList = this.videoList.concat(res.data.result);
          } else {
            this.videoList = res.data.result;
            if (res.data.result[0].type == 1) {
              this.showVideoArea = false;
            } else {
              this.showVideoArea = true;
            }
            this.videoTopSrc = res.data.result[0].redirectUrl;
            this.videoTopimgSrc = res.data.result[0].videoUrl;
            this.videoTopTitle = res.data.result[0].title;
          }
        }
      });
    },
    showVideo(type, val) {
      this.pageNum = 0;
      this.showActive = type;
      this.category = val;
      this.getVideoData();
    },
    calTimes(item, type) {
      if (type == 1) {
        this.showVideoArea = false;
      } else {
        this.showVideoArea = true;
        this.addTimes(item.id);
      }
      this.videoTopSrc = item.redirectUrl;
      this.videoTopimgSrc = item.videoUrl;
      this.videoTopTitle = item.title;
      this.$nextTick(() => {
        document.getElementById("media").play();
      });
      window.scrollTo(0, 0);
    },
    goUrl(url) {
      window.location.href = url;
    },
    addTimes(id) {
      let data = {
        id: id,
        count: 1,
        companyId: this.companyId
      };
      this.$api.strageList.addTimes(data).then(res => {
        if (res.data && res.data.code == 0) {
          if (res.data.result == true) {
            this.$refs[id][0].innerHTML =
              Number(this.$refs[id][0].innerHTML) + 1;
          }
        }
      });
    },
    loadMore() {
      this.pageNum += this.pageSize;
      this.getVideoData("more");
    }
  },
  components: {
    // videoTutorial,
    backHeader
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.video {
  padding: 0.5rem 0.3rem;
}
@import "~assets/styles/mixin";
.video_tab {
  margin-bottom: 0.3rem;
  ul {
    @include fj();
    li {
      width: 1.57rem;
      @include sc(0.24rem, #666);
      text-align: center;
      border: 0.025rem solid rgba(221, 221, 221, 1);
      padding: 0.11rem 0;
      @include borderRadius(0.06rem);
    }
    li.active {
      background: #0a95ff;
      color: #fff;
    }
  }
}
.video_list {
  ul {
    li {
      float: left;
      margin-bottom: 0.3rem;
      font-size: 0;
      img {
        width: 3.3rem;
        height: 1.86rem;
      }
      .video_wrapper {
        @include borderRadius(0.1rem);
        position: relative;
        overflow: hidden;
        font-size: 0;
        text-align: center;
        video {
          width: 6.9rem;
          height: 3.9rem;
          margin: 0 auto;
        }
        .play_btn {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -0.34rem;
          margin-top: -0.34rem;
          img {
            @include wh(0.68rem, 0.68rem);
          }
        }
      }
      .video_title {
        @include sc(0.32rem, #333);
        margin: 0.2rem 0 0.1rem;
        word-wrap: break-word;
        word-break: break-all;
        width: 3.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .video_times {
        @include sc(0.24rem, #999);
      }
    }
    li:nth-child(odd) {
      margin-right: 0.2rem;
    }
  }
}
.video_window {
  .title {
    @include sc(0.3rem, #333);
    margin-bottom: 0.2rem;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    margin-top: .2rem;
  }
}
.load_more {
  @include sc(0.28rem, #333);
  text-align: center;
}
.video_area{
    @include wh(6.9rem,3.88rem);
    overflow: hidden;
}
.img_area {
  img {
    @include wh(6.9rem,3.88rem)
  }
}
</style>